import {Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {PayorsService} from '../../../payors/payors.service';

@Component({
  selector: 'app-payor-multi-select',
  templateUrl: './payor-multi-select.component.html',
  styleUrls: ['./payor-multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PayorMultiSelectComponent),
      multi: true
    }
  ]
})
export class PayorMultiSelectComponent implements OnInit, ControlValueAccessor, OnChanges {
  @Input() emitOnlyId = false;
  isLoad = false;
  dropdownList =  [];
  selectedItems = [];
  companies = [];
  @Output() payersId: EventEmitter <any> = new EventEmitter <any>();

  dropdownSettings = {
    singleSelection: false,
    idField: 'payorid',
    textField: 'description',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 5,
    allowSearchFilter: true
  };
  private objTmp = [];
  public count = 0;
  public propagateChange: any  = () => {};



  constructor( private payorService: PayorsService) {

  }

  ngOnInit() {
    this.payorService.getPayorList()
      .subscribe((res: any) => {
          this.dropdownList = res;
          this.isLoad = true;
        });

    // if (!this.isLoad) {
    //   setTimeout(() => this.selectedItems = this.updateDD(this.objTmp), 400);
    //   // this.selectedItems = this.updateDD(this.objTmp);
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    if (obj) {
      this.selectedItems = [];
      setTimeout(() => {
        this.selectedItems = this.updateDD(obj);
        // TODO DIFUNDIR LOS ID DE LOS PAYOR SELECCIONADOS
        const payersId = [];
        this.selectedItems.map((item) => {
          payersId.push(item.payorid);
        });
        this.payersId.emit(payersId);
        }, 700);
      // this.selectedItems = this.updateDD(obj);
    }
  }
  updateDD(obj) {
    const varValue = [];
    obj.map((item) => {

      this.dropdownList.map(f => {
        if (item.payorid === f.payorid) {
         varValue.push(f);
        }
      });

    });
    return varValue;

  }

  /**
   * Propagate según Tipo
   */
  emitByType() {
    if (this.emitOnlyId) {
      // TODO DIFUNDIR LOS ID DE LOS PAYOR SELECCIONADOS
      const payersId = [];
      const arrayEmit = this.selectedItems.map((item) => {
        // EMITIR LOS ID DE LOS PEYOR
        payersId.push(item.payorid);
        return {payorid: item.payorid, description: item.description};
      });
      this.propagateChange(arrayEmit);
      // EMITIR LOS ID DE LOS PEYOR
      this.payersId.emit(payersId);
    } else {
      this.propagateChange(this.selectedItems);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/multi-select-dropdown/payor-multi-select/payor-multi-select.component.ts